import { render, staticRenderFns } from "./WebTwoTrainPlanMy.vue?vue&type=template&id=33a74f20&scoped=true&"
import script from "./WebTwoTrainPlanMy.vue?vue&type=script&lang=js&"
export * from "./WebTwoTrainPlanMy.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoTrainPlanMy.vue?vue&type=style&index=0&id=33a74f20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a74f20",
  null
  
)

export default component.exports